import {ResourceRequestParams} from "../../../../../infrastructure/models/params/resource-request-params";

export class GoogleMapsLocationParams extends ResourceRequestParams {
  constructor(placeId: String) {
    super('https://www.google.com/maps/place/?q=place_id:' + placeId, false);
  }

}